import { Icon, type IconProps } from "@chakra-ui/react";

function DarkMode(props: IconProps) {
  return (
    <Icon viewBox="0 0 9 9" {...props}>
      <path color="white" d="M2.39358 5.9613C4.36398 5.9613 5.9613 4.36398 5.9613 2.39358C5.9613 1.47252 5.61227 0.632974 5.03926 0C6.74829 0.485576 8 2.05791 8 3.9226C8 6.17449 6.17449 8 3.9226 8C2.05791 8 0.485576 6.74828 0 5.03926C0.632974 5.61227 1.47252 5.9613 2.39358 5.9613Z" fill="#02C2EB" />
    </Icon>
  );
}

export default DarkMode;
